import React from 'react';
import { makeStyles, rgba } from 'design-system/styles';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { MenuItem } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { INamedEntityRecognitionRelationship } from './namedEntityRecognitionAnnotations';
import { Separator, TextButton } from 'react-scale/components/design-system';
import NERLinkText from './NERLinkText';
import { IColorMap } from './namedEntityRecognitionLabels';
import ReactTooltip from 'react-tooltip';

interface INERLinksMenuProps {
  annotationId: string;
  relationships: INamedEntityRecognitionRelationship[];
  labelColormap: IColorMap;
  hiddenRelationships: { [id: string]: boolean };
  toggleRelationshipVisibility: (id: string) => void;
  onEnterLinkingMode: () => void;
  onRemoveRelationship: (relationshipId: string) => void;
}

const NERLinksMenu: React.FC<INERLinksMenuProps> = ({
  annotationId,
  relationships,
  labelColormap,
  hiddenRelationships,
  toggleRelationshipVisibility,
  onEnterLinkingMode,
  onRemoveRelationship,
}) => {
  const classes = useNERLinksMenuClasses();

  return (
    <div className={classes.linksMenu}>
      <MenuItem className={classes.addLinkButton} onClick={onEnterLinkingMode}>
        + Add link
      </MenuItem>
      <Separator />
      {relationships.map(relationship => {
        const otherAnnotation =
          relationship.source_ref === annotationId
            ? relationship.targetAnnotation
            : relationship.sourceAnnotation;
        return (
          <div key={otherAnnotation.id} className={classes.linkEntry}>
            <FontAwesomeIcon icon={'arrows-h'} className={classes.linkEntryArrow} />
            <NERLinkText
              className={classes.linkEntryText}
              sourceAnnotation={relationship.sourceAnnotation}
              targetAnnotation={relationship.targetAnnotation}
              displayName={relationship.relationshipDefinition.display_name}
              labelColormap={labelColormap}
            />
            <div data-for={`unlink-${otherAnnotation.id}`} data-tip="Unlink">
              <TextButton
                classes={{ root: classes.iconButton }}
                onClick={() => onRemoveRelationship(relationship.id)}
              >
                <FontAwesomeIcon icon="unlink" className={classes.linkEntryDeleteIcon} />
              </TextButton>
            </div>

            <ReactTooltip id={`unlink-${otherAnnotation.id}`} />

            <div
              data-for={`visible-${otherAnnotation.id}`}
              data-tip={hiddenRelationships[relationship.id] ? 'Show' : 'Hide'}
            >
              <TextButton
                classes={{ root: classes.iconButton }}
                onClick={() => toggleRelationshipVisibility(relationship.id)}
              >
                <FontAwesomeIcon
                  icon={hiddenRelationships[relationship.id] ? 'eye' : 'eye-slash'}
                  className={classes.visibleIcon}
                />
              </TextButton>
            </div>

            <ReactTooltip id={`visible-${otherAnnotation.id}`} />
          </div>
        );
      })}
    </div>
  );
};

const useNERLinksMenuClasses = makeStyles({
  linksMenu: {
    minWidth: 200,
    paddingTop: 8,
    paddingBottom: 8,
    pointerEvents: 'all',
  },

  addLinkButton: {
    color: '#000',
    fontWeight: 500,
    fontSize: 14,
  },

  linkEntry: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    marginLeft: 14,
    marginRight: 14,
  },

  linkEntryArrow: {
    width: '20px !important',
    height: '20px !important',
    padding: 2,
    color: rgba('#000', 0.6),
  },

  linkEntryText: {
    marginInline: '6px',
  },

  linkEntryDeleteIcon: {
    width: '20px !important',
    height: '20px !important',
    padding: 2,
    color: rgba('#000', 0.3),
  },

  visibleIcon: {
    width: '25px !important',
    height: '25px !important',
    padding: 2,
    color: rgba('#000', 0.3),
    marginLeft: 2,
  },

  iconButton: {
    width: 'unset !important',
    height: 'unset !important',
    minWidth: 'unset !important',
    padding: 'unset !important',
    marginLeft: 'auto',
    borderRadius: 4,
  },
});

export default NERLinksMenu;
